import React, { useEffect } from "react";
import { useDrop, useDrag } from "react-dnd";
import { Card, CardContent, Typography } from "@material-ui/core";
import update from "immutability-helper";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const ItemTypes = {
  CARD: "card",
};

function VerticalDraggableCard({
  id,
  text,
  index,
  moveCard,
  setSelectedCategory,
  products,
  productsAll,
  selectedCategory
}) {
  const [, ref] = useDrag({
    type: ItemTypes.CARD,
    item: { id, index },
  });

  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover(item) {
      if (item.index !== index) {
        moveCard(item.index, index);
        item.index = index;
      }
    },
  });

  const counter = productsAll.filter(
    (prod) => prod.Category.name === text);
  

  return (
    <Card
      ref={(node) => ref(drop(node))}
      style={{ marginBottom: "10px", cursor: "move", backgroundColor: selectedCategory === text? "#77DD77" : "white" }}
      onClick={() => setSelectedCategory(text)}
    >
      <CardContent>
        <Typography variant="body1">{`${text} (${counter.length})`}</Typography>
      </CardContent>
    </Card>
  );
}

function VerticalDraggableCards({ cards, setCards, setSelectedCategory, products, selectedCategory, productsAll }) {
  const { store } = useStateContext();

  const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
  const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

  const moveCard = (dragIndex, hoverIndex) => {
    const draggedCard = cards[dragIndex];
    const changedWithCard = cards[hoverIndex];

    const payload = {
      params: {
        shopName: databaseStoreName,
        orderCategoryOne: draggedCard.order,
        orderCategoryTwo: changedWithCard.order,
        idCategoryOne: changedWithCard.id,
        idCategoryTwo: draggedCard.id,
      },
    };

    axiosClient
      .patch("categories/changeOrder", payload)
      .catch((err) => console.log(err));

    setCards(
      update(cards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, draggedCard],
        ],
      })
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {cards.map((card, index) => (
        <VerticalDraggableCard
          key={card.id}
          index={index}
          setSelectedCategory={setSelectedCategory}
          id={card.id}
          text={card.name}
          products={products}
          moveCard={moveCard}
          selectedCategory={selectedCategory}
          productsAll={productsAll}
        />
      ))}
    </div>
  );
}

export default VerticalDraggableCards;
